<!-- marquee section  -->
<section class="marquee">
  <div class="wrapper" speed="0.3">
    <li class="boxlist" *ngFor="let item of webinar_header_section">
      <ng-container *ngIf="item.header_url; else noLink">
        <a href="{{ item.header_url }}" target="_blank">{{
          item.header_text
        }}</a>
      </ng-container>
      <ng-template #noLink>
        {{ item.header_text }}
      </ng-template>
    </li>
  </div>
</section>
<!-- marquee section  -->

<!-- main section -->
<section class="register">
  <div class="left">
    <video width="320" height="100" class="player" autoplay loop muted>
      <source
        src="../../../assets/images/retirement-webinar/videos/creative.mp4"
        type="video/mp4"
      />
      Your browser does not support the video tag.
    </video>
          <!-- <img  src="../../../assets/images/retirement-webinar/images/1.jpg" alt="Creative Retirement Webinar" class="player" width="320"  height="100" /> -->

    <div class="content">
      <div class="heading" *ngIf="upcomingWebinarTitle">
        <!-- <h1 class="text">Financial Freedom <span class="sub-text">Post Retirement</span></h1> -->
        <h1 class="text">
          <span class="sub-text">{{ upcomingWebinarTitle }}</span>
        </h1>
      </div>
      <div class="details" *ngIf="upcomingWebinarSpeakerImg">
        <img
          src="{{ upcomingWebinarSpeakerImg }}"
          alt="host"
          class="userimg img-fluid"
        />
        <div class="data">
          <p class="heading">Join the Upcoming Webinar</p>
          <ul class="list">
            <li class="name">{{ upcomingWebinarSpeakerName }}</li>
            <li class="date">
              {{ upcomingWebinarSpeakerDate | date : "dd MMM yyyy "
              }}{{ upcomingWebinarLanguage === "1" ? "(Hindi)" : "" }}
            </li>
            <li class="time">
              {{ upcomingWebinarSpeakerDuration | duration }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="right" *ngIf="Firstregister">
    <div class="reg_form">
      <p
        class="heading all-hide"
        style="margin-bottom: 1rem !important; margin-top: 3rem !important"
      >
      Secure Your Future with NPS – Join Our Exclusive Webinar!
        <!-- at just ₹{{discountAmount}} <span class="bold-strike">₹{{originalamount}}</span> only (limited offer) -->
      </p>
      <div class="all-hide progressbar">
        <div class="statusBar" style="width: 50%"></div>
      </div>
      <p class="heading all-hide" id="heading">
        <!-- The science behind Retirement Planning made easy! Book your slot now -->
      </p>
      <div class="all-hide">
        <div class="owl-ten owl-carousel owl-theme">
          <div class="item" *ngIf="!uniqueWebinar">
            <div class="step-1">
              <div class="content">
                <ul class="timelines" *ngFor="let item of upcomingWebinars">
                  <li>
                    <button
                      class="btn datebtn owlNext"
                      (click)="handleButtonClick(item)"
                    >
                      {{
                        item.Webinar_datetime
                          | date
                            : "dd MMM
                                          yyyy, hh:mm
                                          a "
                      }}{{
                        item.Webinar_language_hindi === "1" ? "(Hindi)" : ""
                      }}
                      <br />With
                      {{ item.webinar_speaker_section[0]["speaker_name"] }}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="step-2" *ngIf="myleadform || uniqueWebinar">
              <div class="content">
                <form
                  autocomplete="off"
                  #leadForm="ngForm"
                  autocomplete="off"
                  (ngSubmit)="tablelead()"
                >
                  <div class="form">
                    <div class="form-group">
                      <label for="name">FULL NAME</label>
                      <input
                        type="text"
                        class="form-control"
                        name="name"
                        id="name"
                        maxlength="50"
                        placeholder="Enter your full name here"
                        (input)="checkName($event)"
                        [(ngModel)]="name"
                        (blur)="removeErrorMsg('name')"
                        inputmode="text" oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '').replace(/\s{2,}/g, ' ');"
                        appAlphaOnly
                        appBlockCopyPaste
                      />
                      <small
                        class="error"
                        *ngIf="nameValidateMessage == 'required'"
                        >This field is mandatory</small
                      >
                      <small
                        class="error"
                        *ngIf="nameValidateMessage == 'lengthError'"
                        >Invalid full name</small
                      >
                    </div>
                    <div class="form-group">
                      <label for="email">EMAIL ADDRESS</label>
                      <input
                        type="email"
                        class="form-control"
                        id="email"
                        placeholder="Enter your Email address here"
                        name="email"
                        [(ngModel)]="email"
                        (blur)="removeErrorMsg('email')"
                        appBlockCopyPaste
                      />
                      <small
                        class="error"
                        *ngIf="emailValidateMessage == 'required'"
                        >This field is mandatory</small
                      >
                      <small
                        class="error"
                        *ngIf="emailValidateMessage == 'invalid'"
                        >Please enter a valid email</small
                      >
                    </div>
                    <div class="form-group" id="mobile_number">
                      <label for="mobile">MOBILE NUMBER</label>
                      <input
                        type="text"
                        class="form-control"
                        id="mobile"
                        placeholder="Enter your mobile number"
                        name="mobile"
                        [(ngModel)]="mobile"
                        (blur)="removeErrorMsg('mobile')"
                        appBlockCopyPaste
                        minlength="10"
                        maxlength="10"
                        (input)="showGenerateOtpBtn()"
                        inputmode="numeric" oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                        (keypress)="numbersOnly($event)"
                        (keydown)="onKeyDown($event)"
                      />
                      <div
                        style="display: none"
                        class="otpdiv"
                        id="generateOtp"
                      >
                        <a
                          class="btn generate"
                          id="send_otp"
                          (click)="generateOtp()"
                          >Generate OTP</a
                        >
                      </div>
                      <small
                        class="error"
                        *ngIf="mobileValidateMessage == 'lengthError'"
                      >
                        10 digit mobile number is mandatory
                      </small>
                      <small
                        class="error"
                        *ngIf="mobileValidateMessage == 'invalid'"
                      >
                        Invalid mobile number
                      </small>
                      <small
                        class="error"
                        *ngIf="mobileValidateMessage == 'required'"
                      >
                        Mobile number is mandatory
                      </small>
                      <small
                        class="error"
                        *ngIf="mobileValidateMessage == 'verifyOtp'"
                      >
                        Please verify your mobile number
                      </small>
                    </div>
                    <div class="form-group" id="otpdiv" style="display: none">
                      <label for="mobile" id="editnumber"
                        ><span class="material-icons-outlined">
                          chevron_left </span
                        >EDIT MOBILE NUMBER</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="otp"
                        placeholder="Enter OTP here"
                        id="otp"
                        name="otp"
                        [(ngModel)]="otp"
                        minlength="6"
                        maxlength="6"
                        inputmode="numeric" oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                        (keypress)="numbersOnlyotp($event)"
                        (blur)="removeErrorMsg('otp')"
                        (keyup)="verifyOtp()"
                        [disabled]="otpVerified"
                      />

                      <div class="otpdiv">
                        <div id="timer">
                          <span class="timer" *ngIf="isTimer"
                            >Didn't recieve OTP? Resend in
                            <strong style="font-size: 17px"
                              >{{ timeleft }} </strong
                            >seconds</span
                          >
                          <a
                            id="resend"
                            class="resendeotp"
                            href="javascript:void(0)"
                            *ngIf="isResend"
                            (click)="resendOTP()"
                            >Resend OTP</a
                          >
                        </div>
                      </div>
                      <div
                        class="error"
                        *ngIf="otpValidateMessage && !invalidOtpStatus"
                      >
                        OTP is mandatory
                      </div>
                      <div class="error" *ngIf="invalidOtpStatus">
                        Invalid OTP
                      </div>
                      <div class="text-success">
                        {{ otpVerify }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="pincode">PINCODE</label>
                      <input
                        type="text"
                        class="form-control"
                        id="pincode"
                        placeholder="Enter your pincode here"
                        name="pincode"
                        pattern="^[1-9][0-9]{5}$" minlength="6" maxlength="6"
                        [(ngModel)]="pincode"
                        (blur)="removeErrorMsg('pincode')"
                        inputmode="numeric" oninput="this.value = this.value.replace(/^0|[^0-9]/g, '');"
                        appBlockCopyPaste
                      />
                      <small
                        class="error"
                        *ngIf="pincodeValidateMessage == 'required'"
                        >This field is mandatory</small
                      >
                      <small
                        class="error"
                        *ngIf="pincodeValidateMessage == 'invalid'"
                        >Invalid pincode</small
                      >
                    </div>

                    <div class="ctas" *ngIf="!uniqueWebinar">
                      <a class="btn secondary owlPrev" id="back">Back</a>
                      <button
                        class="btn primary"
                        (click)="checkValidationMsg(leadForm)"
                        id="registerback"
                      >
                        Register
                      </button>
                    </div>

                    <div
                      class="ctas justify-content-center"
                      *ngIf="uniqueWebinar"
                    >
                      <button
                        class="btn primary"
                        (click)="checkValidationMsg(leadForm)"
                        id="registerback"
                      >
                        Pay to register
                      </button>
                    </div>
                    <p style="text-align: center">Register for the webinar</p>
                    <p class="terms">
                      By continuing, you provide consent and agree to our
                      <a
                        [routerLink]="['/term-conditions']"
                        [queryParams]="{ doc: 'tnc' }"
                      >
                        Terms & Conditions</a
                      >
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="main_loader" style="display: none">
        <div class="loader-wrapper">
          <div class="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
      <div class="step-3" *ngIf="thankyou">
        <div class="content">
          <img
            src="../../../assets/images/retirement-webinar/images/check.png"
            class="img-fluid check"
            alt="check"
          />
          <h4 class="heading">Thank you</h4>
          <h5 class="subheading">for registering for the NPS webinar.</h5>
          <p class="date">{{ selectedDate | date : "dd MMM yyyy, hh:mm a" }}</p>
          <div class="text"></div>
        </div>
        <div class="bottom_nav"></div>
      </div>
    </div>
  </div>
</section>
<!-- main section -->

<!-- speaker section  -->
<section class="speaker">
  <div class="container">
    <p class="tagline">{{ webinar_banner_desc }}</p>
    <h4 class="heading">Featured Speaker</h4>
    <div class="owl-two owl-carousel owl-theme">
      <div class="item" *ngFor="let item of featured_speaker">
        <div class="host_box">
          <div class="host_card">
            <div class="svgs">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="303"
                height="57"
                viewBox="0 0 303 57"
                fill="none"
              >
                <path
                  d="M0 0H303L271.5 57H0V0Z"
                  fill="url(#paint0_linear_1112_4969)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_1112_4969"
                    x1="151.5"
                    y1="0"
                    x2="151.5"
                    y2="57"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#E9C032" />
                    <stop offset="1" stop-color="#E9C032" stop-opacity="0" />
                  </linearGradient>
                </defs>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="280"
                height="56"
                viewBox="0 0 280 56"
                fill="none"
              >
                <path
                  d="M0 0H280L250.891 56H0V0Z"
                  fill="url(#paint0_linear_1112_4970)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_1112_4970"
                    x1="140"
                    y1="0"
                    x2="140"
                    y2="56"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#E9C032" />
                    <stop offset="1" stop-color="#E9C032" stop-opacity="0" />
                  </linearGradient>
                </defs>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="258"
                height="57"
                viewBox="0 0 258 57"
                fill="none"
              >
                <path
                  d="M0 0H258L231.178 57H0V0Z"
                  fill="url(#paint0_linear_1112_4971)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_1112_4971"
                    x1="129"
                    y1="0"
                    x2="129"
                    y2="57"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#E9C032" />
                    <stop offset="1" stop-color="#E9C032" stop-opacity="0" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div class="host_img">
              <img
                src="{{ item.webinar_speaker_image }}"
                class="img-fluid image"
                alt="{{ item.webinar_speaker_image_alt_text }}"
              />
            </div>
            <div class="host_details">
              <small class="hosted">HOSTED BY</small>
              <p class="name">{{ item.webinar_speaker_name }}</p>
              <small class="designation"
                >{{ item.webinar_speaker_designation }},
                {{ item.webinar_speaker_organization }}</small
              >
              <div class="audio">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="73"
                  height="67"
                  viewBox="0 0 73 67"
                  fill="none"
                >
                  <ellipse cx="46" cy="27.6" rx="27" ry="27.6" fill="#E9BD32" />
                  <path
                    d="M56.0242 23.5007H55.0215C54.4676 23.5007 54.0189 23.9593 54.0189 24.5256V27.6004C54.0189 32.3919 49.9776 36.2366 45.1963 35.76C41.0291 35.3443 37.9767 31.5149 37.9767 27.2352V24.5256C37.9767 23.9593 37.528 23.5007 36.974 23.5007H35.9714C35.4174 23.5007 34.9688 23.9593 34.9688 24.5256V27.0982C34.9688 32.8403 38.9774 37.9591 44.4938 38.7367V40.9243H40.9846C40.4306 40.9243 39.9819 41.383 39.9819 41.9492V42.9741C39.9819 43.5404 40.4306 43.9991 40.9846 43.9991H51.011C51.5649 43.9991 52.0136 43.5404 52.0136 42.9741V41.9492C52.0136 41.383 51.5649 40.9243 51.011 40.9243H47.5017V38.7611C52.8727 38.0078 57.0268 33.2951 57.0268 27.6004V24.5256C57.0268 23.9593 56.5781 23.5007 56.0242 23.5007ZM45.9978 33.7499C49.3203 33.7499 52.0136 30.9967 52.0136 27.6004H46.6664C46.2973 27.6004 45.9978 27.371 45.9978 27.0879V26.063C45.9978 25.7798 46.2973 25.5505 46.6664 25.5505H52.0136V23.5007H46.6664C46.2973 23.5007 45.9978 23.2714 45.9978 22.9882V21.9633C45.9978 21.6802 46.2973 21.4508 46.6664 21.4508H52.0136V19.401H46.6664C46.2973 19.401 45.9978 19.1717 45.9978 18.8886V17.8636C45.9978 17.5805 46.2973 17.3512 46.6664 17.3512H52.0136C52.0136 13.9548 49.3203 11.2017 45.9978 11.2017C42.6753 11.2017 39.9819 13.9548 39.9819 17.3512V27.6004C39.9819 30.9967 42.6753 33.7499 45.9978 33.7499Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div class="host_text">
            <p [innerHTML]="item.webinar_speaker_description"></p>
          </div>
        </div>
      </div>
    </div>
    <h4 class="heading">This Exclusive Webinar by BajajCapital focuses on:</h4>
    <div class="owl-three owl-carousel owl-theme">
      <div class="item">
        <div class="focus_box">
          <img
            src="../../../assets/images/retirement-webinar/images/icons/focus1.png"
            class="img-fluid icon"
            alt="icon"
          />
          <p class="text">NPS Vatsalya: A unique pension scheme for minors – helping parents/guardians build a secure financial future for their children.</p>
        </div>
      </div>
      <div class="item">
        <div class="focus_box">
          <img
            src="../../../assets/images/retirement-webinar/images/icons/focus2.png"
            class="img-fluid icon"
            alt="icon"
          />
          <p class="text">Government-backed & regulated by PFRDA for security</p>
        </div>
      </div>
      <div class="item">
        <div class="focus_box">
          <img
            src="../../../assets/images/retirement-webinar/images/icons/focus3.png"
            class="img-fluid icon"
            alt="icon"
          />
          <p class="text">Tax savings of up to 2 lakh under Sections 80C & 80CCD(1B)</p>
        </div>
      </div>
      <div class="item">
        <div class="focus_box">
          <img
            src="../../../assets/images/retirement-webinar/images/icons/focus4.png"
            class="img-fluid icon"
            alt="icon"
          />
          <p class="text">Low-risk, affordable investments with market-linked returns</p>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- speaker section  -->

<!-- testimonial section  -->
<section class="testimonial">
  <div class="container">
    <div class="owl-four owl-carousel owl-theme">
      <div class="item" *ngFor="let item of webinar_testimonial_section">
        <div class="row">
          <div class="col-xl-7 col-lg-7 col-md-12">
            <div class="content">
              <h4 class="heading">{{ item.testimonial_title }}</h4>
              <p class="text">{{ item.testimonial_description }}</p>
              <p class="name">
                {{ item.testimonial_name }}, {{ item.testimonial_city }}
              </p>
            </div>
          </div>
          <div class="col-xl-5 col-lg-5 col-md-12">
            <div class="userimg">
              <video
                *ngIf="!isImage(item.testimonial_media)"
                playsinline
                autoplay
                loop
              >
                <source src="{{ item.testimonial_media }}" type="video/mp4" />
              </video>
              <img
                *ngIf="isImage(item.testimonial_media)"
                src="{{ item.testimonial_media }}"
                class="img-fluid"
                alt="{{ item.img_alt_text }}"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- testimonial section  -->

<!-- upcoming webinar section  -->
<section class="upcoming" *ngIf="upcomingWebinars.length">
  <div class="container">
    <h4 class="heading">Upcoming Webinars</h4>
    <div class="row">
      <div
        class="col-xl-4 col-lg-4 col-md-12"
        *ngFor="let item of upcomingWebinars"
      >
        <div class="boxs">
          <p *ngIf="item.Webinar_tag" class="badge">
            {{
              item.Webinar_tag.toLowerCase().trim() === "filling fast"
                ? item.Webinar_tag + "⚡"
                : item.Webinar_tag
            }}
          </p>
          <div class="box_details">
            <img
              src="{{ item.webinar_speaker_section[0]['image'] }}"
              alt="{{ item.webinar_speaker_section[0]['img_alt_text'] }}"
              class="img-fluid host"
            />
            <div class="host_text">
              <h5 class="title">{{ item.webinar_title }}</h5>
              <p class="name">
                {{ item.webinar_speaker_section[0]["speaker_name"] }}
              </p>
            </div>
          </div>
          <a class="btn" (click)="scrollUp()"
            >{{ item.Webinar_datetime | date : "dd MMM yyyy, hh:mm a "
            }}{{ item.Webinar_language_hindi === "1" ? "(Hindi)" : "" }}</a
          >
        </div>
      </div>
    </div>
  </div>
</section>
<!-- upcoming webinar section  -->

<!-- bottom sticky bar -->
<section class="bottombar">
  <div class="container">
    <div class="tabs">
      <div class="home">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M6 19H9V13H15V19H18V10L12 5.5L6 10V19ZM4 21V9L12 3L20 9V21H13V15H11V21H4Z"
            fill="#7A7A7A"
          />
        </svg>
        <p class="heading">Make a Retirement Plan</p>
      </div>
      <div class="webinar">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M20.25 3.75H3.75C3.35218 3.75 2.97064 3.90804 2.68934 4.18934C2.40804 4.47064 2.25 4.85218 2.25 5.25V18.75C2.25 19.1478 2.40804 19.5294 2.68934 19.8107C2.97064 20.092 3.35218 20.25 3.75 20.25H5.00531C5.14726 20.25 5.2863 20.2098 5.40628 20.134C5.52627 20.0581 5.62227 19.9498 5.68313 19.8216C6.04783 19.0516 6.62363 18.4009 7.34357 17.9453C8.06351 17.4897 8.898 17.2478 9.75 17.2478C10.602 17.2478 11.4365 17.4897 12.1564 17.9453C12.8764 18.4009 13.4522 19.0516 13.8169 19.8216C13.8777 19.9498 13.9737 20.0581 14.0937 20.134C14.2137 20.2098 14.3527 20.25 14.4947 20.25H20.25C20.6478 20.25 21.0294 20.092 21.3107 19.8107C21.592 19.5294 21.75 19.1478 21.75 18.75V5.25C21.75 4.85218 21.592 4.47064 21.3107 4.18934C21.0294 3.90804 20.6478 3.75 20.25 3.75ZM7.5 13.5C7.5 13.055 7.63196 12.62 7.87919 12.25C8.12643 11.88 8.47783 11.5916 8.88896 11.4213C9.3001 11.251 9.7525 11.2064 10.189 11.2932C10.6254 11.38 11.0263 11.5943 11.341 11.909C11.6557 12.2237 11.87 12.6246 11.9568 13.061C12.0436 13.4975 11.999 13.9499 11.8287 14.361C11.6584 14.7722 11.37 15.1236 11 15.3708C10.63 15.618 10.195 15.75 9.75 15.75C9.15326 15.75 8.58097 15.5129 8.15901 15.091C7.73705 14.669 7.5 14.0967 7.5 13.5ZM20.25 18.75H14.9466C14.3203 17.6732 13.3762 16.8165 12.2438 16.2975C12.8115 15.792 13.2122 15.1258 13.3927 14.3874C13.5732 13.649 13.5251 12.8731 13.2546 12.1627C12.9842 11.4522 12.5042 10.8408 11.8783 10.4093C11.2524 9.97787 10.5102 9.74684 9.75 9.74684C8.98982 9.74684 8.24758 9.97787 7.6217 10.4093C6.99581 10.8408 6.51582 11.4522 6.24536 12.1627C5.9749 12.8731 5.92675 13.649 6.10728 14.3874C6.28782 15.1258 6.68851 15.792 7.25625 16.2975C6.12385 16.8165 5.17975 17.6732 4.55344 18.75H3.75V5.25H20.25V18.75ZM5.25 9V7.5C5.25 7.30109 5.32902 7.11032 5.46967 6.96967C5.61032 6.82902 5.80109 6.75 6 6.75H18C18.1989 6.75 18.3897 6.82902 18.5303 6.96967C18.671 7.11032 18.75 7.30109 18.75 7.5V16.5C18.75 16.6989 18.671 16.8897 18.5303 17.0303C18.3897 17.171 18.1989 17.25 18 17.25H16.5C16.3011 17.25 16.1103 17.171 15.9697 17.0303C15.829 16.8897 15.75 16.6989 15.75 16.5C15.75 16.3011 15.829 16.1103 15.9697 15.9697C16.1103 15.829 16.3011 15.75 16.5 15.75H17.25V8.25H6.75V9C6.75 9.19891 6.67098 9.38968 6.53033 9.53033C6.38968 9.67098 6.19891 9.75 6 9.75C5.80109 9.75 5.61032 9.67098 5.46967 9.53033C5.32902 9.38968 5.25 9.19891 5.25 9Z"
            fill="#DA2128"
          />
        </svg>
        <p class="heading active">Register for Webinar</p>
      </div>
    </div>
  </div>
</section>
<!-- bottom sticky bar -->

<!-- main section -->

<!-- webinar complete modal  -->
<div class="webinar-modal" id="cancelwebinar">
  <p class="text">We're sorry, this webinar is no longer in session.</p>
</div>
<!-- webinar complete modal  -->

<div class="webinar-modal" id="alreadyregister">
  <img
    src="../../../assets/images/retirement-webinar/images/success-x.png"
    class="calendar-x"
    width="24"
    height="24"
    alt="calendar-x"
  />
  <p class="text">Oops you have already registered for webinar</p>
</div>

<div class="webinar-modal" id="registerFirst">
  <p class="text">Woops! You have not registered yet. Please register first.</p>
</div>

<div class="webinar-modal" id="webinarotp">
  <p class="text">Woops! No Registration for this mobile number</p>
</div>

<div class="webinar-modal" id="userBlocked">
  <p class="text">You are not allowed join. Please contact Administrator</p>
</div>

<div class="webinar-modal" id="uniqueWebinarErr">
  <p class="text">
    We're sorry, The webinar you're trying to join doesn't exist. Please
    register for an upcoming webinar.
  </p>
</div>
